// extracted by mini-css-extract-plugin
export var root = "+MuG";
export var rootContainer = "+DO2";
export var rootInfo = "wLP3";
export var rootInfoHeading = "_9gPZ";
export var rootInfoLink = "_1YnS";
export var rootTiles = "haZu";